import { ComponentFactoryResolver, Injectable } from '@angular/core'
import { OutletService } from '@spartacus/storefront'
import { EbComponentConfig } from '../interfaces/eb-form.interface'

@Injectable({ providedIn: 'root' })
export class EbFormComponentRendererService {
  protected outletRefs = new Map()

  constructor(
    protected outletService: OutletService,
    protected componentFactoryResolver: ComponentFactoryResolver
  ) {}

  render(config: EbComponentConfig, path: string) {
    if (this.outletRefs.has(path)) {
      return
    }
    this.outletRefs.set(path, true)
    const template = this.componentFactoryResolver.resolveComponentFactory(config.component)
    this.outletService.add(path, template as any)
  }
}
